'use strict';
import templateUrl from './victoropsIntegration.html';

/* jshint camelcase: false */
angular.module('sfx.ui').directive('sfxVictoropsIntegration', [
    'notificationService',
    function (notificationService) {
        return {
            restrict: 'E',
            scope: true,
            require: '^sfxIntegration',
            templateUrl,
            link: function ($scope) {
                const reset = function () {
                    $scope.credential.name = $scope.credential.name || 'VictorOps';
                    $scope.temp = { postUrl: '' };
                    $scope.sharedCredentialState.updateCredentials = false;
                    $scope.lastModifiedTs = notificationService.formatNotificationEventTimestamp(
                        $scope.credential.lastUpdated
                    );
                };

                reset();

                $scope.$on('reset', reset);
                $scope.$watch('temp.postUrl', function (newValue) {
                    if (newValue) {
                        $scope.credential.postUrl = newValue;
                        $scope.sharedCredentialState.updateCredentials = true;
                    } else {
                        $scope.credential.postUrl = null;
                    }
                });
            },
        };
    },
]);
